import React from "react";
import Emp_Files_Page from "./Emp_Files_Page";

// Thin wrapper — same shared component as Form-16 / Healthcard, with the
// `kind="eletter"` prop. E-Letter adds a configurable "Letter Type" dropdown
// and talks to the emp_eletter table + Emp_E-Letter_Uploades folder.
export default function Emp_E_Letter_Files({ navSize }) {
    return <Emp_Files_Page navSize={navSize} kind="eletter" />;
}
